
<template>
    <template v-if="entry?.sectionHandle === 'agenda'">
        <BaseCard
            :to="`/${entry?.uri}`"
            :title="entry?.cardDetails?.title ?? entry?.projectHero?.[0]?.title ?? entry?.defaultHero?.[0]?.title ?? entry?.title"
            :description="fullDate"
            :image="entry?.cardDetails?.image?.[0] ?? entry?.projectHero?.[0]?.image?.[0]"
            :buurt="entry?.neighbourhoodRelation?.[0]"
        />
    </template>
    <template v-else-if="entry?.sectionHandle === 'projects'">
        <BaseCard
            :to="`/${entry?.uri}`"
            :title="entry?.cardDetails?.title ?? entry?.projectHero?.[0]?.title ?? entry?.defaultHero?.[0]?.title ?? entry?.title"
            description="Buurtproject"
            :image="entry?.cardDetails?.image?.[0] ?? entry?.projectHero?.[0]?.image?.[0]"
            :buurt="entry?.neighbourhoodRelation?.[0]"
        />
    </template>
    <template v-else-if="entry?.sectionHandle === 'news'">
        <BaseCard
            :to="`/${entry?.uri}`"
            :title="entry?.cardDetails?.title ?? entry?.projectHero?.[0]?.title ?? entry?.defaultHero?.[0]?.title ?? entry?.title"
            :description="postDate"
            :image="entry?.cardDetails?.image?.[0] ?? entry?.projectHero?.[0]?.image?.[0]"
            :buurt="entry?.neighbourhoodRelation?.[0]"
        />
    </template>
    <template v-else>
        <BaseCard
            :to="`/${entry?.uri}`"
            :title="entry?.cardDetails?.title ?? entry?.projectHero?.[0]?.title ?? entry?.defaultHero?.[0]?.title ?? entry?.title"
            :description="entry?.cardDetails?.description ?? entry?.parent?.title"
            :image="entry?.cardDetails?.image?.[0] ?? entry?.projectHero?.[0]?.image?.[0]"
        />
    </template>
</template>

<script setup>
const props = defineProps({
    entry: {
        type: Object,
        default: null
    }
});

const { fullDate } = useFormatDate(props.entry?.dateRange?.start, props.entry?.dateRange?.end);

const { startDate: postDate } = useFormatDate(props.entry?.postDate);
</script>
